import React, { useEffect, useState } from 'react'
import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import AwsConfig from '../../Config/AwsConfig'
import createMovieCollectionService from '../../Services/Mutations/CreateMovieCollectionService'
import { Auth } from 'aws-amplify'
import UpdateMovieCollectionService from '../../Services/Mutations/UpdateMovieCollectionService'
import UpdateMovieCollectionDataService from '../../Services/Mutations/UpdateMovieCollectionDataService'
import { toast } from 'react-toastify'
import { ToastStyle } from '../Data/MovieStaticData'
import UpdateCollectionStatusService from '../../Services/Mutations/UpdateCollectionStatusService'
import { useHistory } from 'react-router-dom'
import CreateCollectionUi from './CreateCollectionUi'
import TagPersonsAtHeaderLevelToMovieCollectionService from '../../Services/Mutations/TagPersonsAtHeaderLevelToMovieCollectionService'
import UntagpersonHeaderCollection from './UntagpersonHeaderCollection'
import PosterCdnCheck from './PosterCdnCheck'
import GetCollectionPermissions from './GetCollectionPermissions'
import { editedORnotValue } from '../Data/StaticPersonandMoviedata'

export default function CreateCollectionList(props) {
  const { response, mode, movieCollectionIDSData, headerLevel } = props
  const [titleEn, setTitleEn] = useState('')
  const [titleTe, setTitleTe] = useState('')
  const [imageValue, setImageValue] = useState('')
  const [discriptionEn, setDiscriptionEn] = useState('')
  const [discriptionTe, setDiscriptionTe] = useState('')
  const [isVisiable, setIsVisiable] = useState(false)
  const [selectedList, setSelectedList] = useState([])
  const [image, setImage] = useState('')
  const [imagePreview, setImagePreview] = useState('')
  const [movieCollectionID, setmovieCollectionID] = useState('')
  const [loading, setLoading] = useState(false)
  const [ApproveOption, setApproveOptionBoolean] = useState(false)
  const [loadPopup, setLoadPopup] = useState(false)
  const [headerLevelPersons, setHeaderLevelPersons] = useState([])
  const [collectionStatus, setCollectionStatus] = useState('draft')
  const [HorizontalImage, setHorizontalImage] = useState(false)
  const [valueChanged, setvalueChanged] = useState(editedORnotValue)

  const history = useHistory()

  const disableButton =
    titleEn === '' ||
    titleTe === '' ||
    discriptionEn === '' ||
    discriptionTe === '' ||
    selectedList.length === 0 ||
    !HorizontalImage ||
    !Object.values(valueChanged).some(e => e === true)
  const disableAddListButton =
    titleEn === '' || titleTe === '' || discriptionEn === '' || discriptionTe === ''
  const sendSelectedList = data => {
    setSelectedList(data)
  }

  const TagAndUntag = async loggedInUserHandle => {
    const responseHeaderTag = await TagPersonsAtHeaderLevelToMovieCollectionService({
      movieCollectionID: movieCollectionID ? movieCollectionID : '',
      addedByID: Auth.user.username,
      addedByHandle: loggedInUserHandle,
      personIDs: headerLevelPersons.map(e => (e.personID ? e.personID : e.PK)),
    })
    if (responseHeaderTag.statusCode === 'A052') {
      toast.success(responseHeaderTag.statusMessage, ToastStyle)
    }

    UntagpersonHeaderCollection(headerLevel, headerLevelPersons, movieCollectionID)
  }

  useEffect(() => {
    const getPermissions = async () => {
      const EDitApproveOption = await GetCollectionPermissions()
      setApproveOptionBoolean(EDitApproveOption)
    }

    getPermissions()
  }, [])
  const createListCollection = async () => {
    setLoading(true)
    let loggedInUserHandle = ''

    const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''

    if (loggedInUserEmail) {
      const emailParams = loggedInUserEmail.split('@')

      loggedInUserHandle = '@' + emailParams[0]
    }

    const movieListIDs = selectedList.filter(e => e !== null).map(item => item.SK)
    const cdnurl = AwsConfig.movieCdnUrl
    if (mode === 'edit') {
      const response = await UpdateMovieCollectionService({
        PK: movieCollectionID ? movieCollectionID.split('#')[0] : '',
        SK: movieCollectionID,
        title_En: titleEn,
        title_Te: titleTe,
        description_En: discriptionEn,
        description_Te: discriptionTe,
        moderatorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
        movieCollectionImage: imagePreview
          ? imagePreview.replace(cdnurl, '')
          : selectedList[0].movieListImage,
      })
      if (response.statusCode === 'A041') {
        TagAndUntag(loggedInUserHandle, response)
      }

      if (response.statusCode === 'A041') {
        const responseUpdate = await UpdateMovieCollectionDataService({
          // movieCollectionID:PK,
          movieCollectionID,
          listsInfo: movieListIDs.map((id, index) => ({ listID: id, priority: index })),
          moderatorID: Auth.user.username,
          moderatorHandle: loggedInUserHandle,
        })
        if (responseUpdate.statusCode === 'A043') {
          toast.success(responseUpdate.statusMessage, ToastStyle)
          if (ApproveOption && collectionStatus === 'draft') {
            setLoading(false)
            setLoadPopup(true)
          } else {
            setTimeout(() => {
              setLoading(false)
              navigateTOpage(movieCollectionID)
            }, 1000)
          }
        }
      }
    } else {
      const response = await createMovieCollectionService({
        title_En: titleEn,
        title_Te: titleTe,
        description_En: discriptionEn,
        description_Te: discriptionTe,
        moderatorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
        movieCollectionImage: imagePreview
          ? imagePreview.replace(cdnurl, '')
          : selectedList[0].movieListImage,
      })
      //
      if (response.statusCode === 'A040') {
        setmovieCollectionID(response.SK)
        //
        if (response.statusCode === 'A040' && headerLevelPersons.length >= 1) {
          //
          const responseHeaderTag = await TagPersonsAtHeaderLevelToMovieCollectionService({
            movieCollectionID: response.SK ? response.SK : '',
            addedByID: Auth.user.username,
            addedByHandle: loggedInUserHandle,
            // const personIDs = headerLevelPersons?.map(e => (e.personID ? e.personID : e.PK))
            personIDs: headerLevelPersons.map(e => (e.personID ? e.personID : e.PK)),
          })
          //
          if (responseHeaderTag.statusCode === 'A052') {
            toast.success(responseHeaderTag.statusMessage, ToastStyle)
          }
        }

        const responseDataCollection = await UpdateMovieCollectionDataService({
          movieCollectionID: response.SK ? response.SK : '',
          listsInfo: movieListIDs.map((id, index) => ({ listID: id, priority: index })),
          moderatorID: Auth.user.username,
          moderatorHandle: loggedInUserHandle,
        })

        if (responseDataCollection.statusCode === 'A043') {
          toast.success(responseDataCollection.statusMessage, ToastStyle)
          if (ApproveOption) {
            setLoading(false)
            setLoadPopup(true)
          } else {
            setTimeout(() => {
              setLoading(false)
              navigateTOpage(response.SK ? response.SK : '')
            }, 1000)
          }
        }
      }
    }
  }

  const uploadSelectedImage = async () => {
    const randomId = await uuidv4()
    const moviePath = AwsConfig.moviePathUrl
    const key = moviePath + randomId + '.jpeg'
    const params = {
      key,
      mimeType: 'image/jpeg',
    }
    const preSignedURLObject = await MovieImagePresignedUrl(params)
    const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
    const signedURL = signedURLObject.data.url
    try {
      const formData = new FormData()
      Object.keys(signedURLObject.data.fields).forEach(key => {
        formData.append(key, signedURLObject.data.fields[key])
      })

      formData.append('file', image)

      await axios({
        method: 'post',
        url: signedURL,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      const cdnurl = AwsConfig.movieCdnUrl
      const posterUrl = cdnurl + key
      setImagePreview(posterUrl)
    } catch {
      // console.warn(err, 'err')
    }
  }

  const navigateTOpage = movieCollectionID => {
    if (mode === 'edit') {
      history.go('/editmoviecollection?' + encodeURI(movieCollectionID.replace('#', '$')))
    } else {
      history.push('/editmoviecollection?' + encodeURI(movieCollectionID.replace('#', '$')))
      window.location.reload(false)
    }
  }

  const approveCollection = async () => {
    const response = await UpdateCollectionStatusService({
      movieCollectionID,
      status: 'published',
    })
    if (response.statusCode === 'M022') {
      toast.success(response.statusMessage, ToastStyle)
      navigateTOpage(movieCollectionID)
    }
  }

  const ClosePopup = () => {
    setLoadPopup(false)
    navigateTOpage(movieCollectionID)
  }

  const selectImage = event => {
    const file = event.target.files[0]
    const valueChangedTemp = { ...valueChanged }
    valueChangedTemp.image = true
    setvalueChanged(valueChangedTemp)
    setImage(file)
    setImageValue('')
  }

  const toggleSearchbar = () => {
    setIsVisiable(!isVisiable)
  }

  // const TitleEn = value => {
  //   setTitleEn(value)
  // }

  // const TitleTe = value => {
  //   setTitleTe(value)
  // }

  // const Discription = value => {
  //   setDiscriptionEn(value)
  // }

  // const DiscriptionTe = value => {
  //   setDiscriptionTe(value)
  // }

  useEffect(() => {
    if (image) {
      uploadSelectedImage()
    }
  }, [image])
  useEffect(() => {
    if (mode === 'edit') {
      // setLoading(true)
      if (response && response) {
        setTitleEn(response.title_En ? response.title_En : '')
        setTitleTe(response.title_Te ? response.title_Te : '')
        setDiscriptionEn(response.description_En ? response.description_En : '')
        setDiscriptionTe(response.description_Te ? response.description_Te : '')
        setImagePreview(
          response.movieCollectionImage ? PosterCdnCheck(response.movieCollectionImage) : '',
        )
        setmovieCollectionID(response.movieCollectionID ? response.movieCollectionID : '')
        setSelectedList(movieCollectionIDSData ? movieCollectionIDSData : [])
        setLoading(false)
        setHeaderLevelPersons(headerLevel ? headerLevel : [])
        setCollectionStatus(response.movieCollectionStatus ? response.movieCollectionStatus : '')
      }
    }
  }, [response, movieCollectionIDSData, mode, headerLevel])
  return (
    <CreateCollectionUi
      imageValue={imageValue}
      loading={loading}
      titleEn={titleEn}
      titleTe={titleTe}
      discriptionEn={discriptionEn}
      discriptionTe={discriptionTe}
      valueChanged={valueChanged}
      setvalueChanged={setvalueChanged}
      // TitleEn={TitleEn}
      // TitleTe={TitleTe}
      // Discription={Discription}
      // DiscriptionTe={DiscriptionTe}
      setTitleEn={setTitleEn}
      setTitleTe={setTitleTe}
      setDiscriptionEn={setDiscriptionEn}
      setDiscriptionTe={setDiscriptionTe}
      selectImage={selectImage}
      imagePreview={imagePreview}
      setImagePreview={setImagePreview}
      toggleSearchbar={toggleSearchbar}
      disableAddListButton={disableAddListButton}
      isVisiable={isVisiable}
      selectedList={selectedList}
      sendSelectedList={sendSelectedList}
      createListCollection={createListCollection}
      disableButton={disableButton}
      loadPopup={loadPopup}
      ClosePopup={ClosePopup}
      approveCollection={approveCollection}
      mode={mode}
      headerLevel={headerLevelPersons}
      setHeaderLevelPersons={setHeaderLevelPersons}
      collectionStatus={collectionStatus}
      setHorizontalImage={setHorizontalImage}
      HorizontalImage={HorizontalImage}
      editData={response}
      movieCollectionIDSData={movieCollectionIDSData}
      editHeader={headerLevel}
    />
  )
}
